<template>
  <div
    class="gl-select-button-wrapper"
    :class="[
      {
        'gl-select-button__gray': grey,
        'gl-select-button__gray--wide': grey && grayPadding === 'wide',
        'gl-select-button__underline': underline,
      },
    ]"
  >
    <template v-for="(item, i) in options">
      <div
        v-if="!item.hide"
        :key="i"
        class="gl-select-button__item"
        :class="[
          { 'gl-select-button__item--active': item.value === value?.value },
          { 'gl-select-button__disabled': disabled },
          { 'gl-select-button__item--disabled': item.disabled },
        ]"
        @click="itemClick(item)"
      >
        <div
          v-if="item.profit"
          class="gl-select-button__item--profit"
        >
          {{ item.profit }}
        </div>
        <slot
          :item="item"
          name="item-slot"
        >
          {{ item.name }}
        </slot>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Object],
      default: null,
    },
    options: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    grey: {
      type: Boolean,
      default: false,
    },
    grayPadding: {
      type: String,
      default: 'compact',
      validator: (v) => ['compact', 'wide'].includes(v),
    },
    underline: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    itemClick(item) {
      if (item.disabled || this.disabled) return
      this.$emit('input', item)
    },
  },
}
</script>

<style>
.gl-select-button-wrapper {
  display: flex;
  width: fit-content;
  background-color: var(--pale-blue-transparent);
  border-radius: 8px;
  height: 40px;
  flex-shrink: 0;
  padding: 4px;
}

.gl-select-button__item {
  position: relative;
  display: inline-flex;
  padding: 8px 29px;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  cursor: pointer;
  color: var(--accent-reflex-blue, #5a78ea);
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 100%; /* 16px */
}

.gl-select-button__item--active {
  color: var(--white);
  background-color: var(--accent-reflex-blue, #5a78ea);
}

.gl-select-button__disabled {
  cursor: not-allowed;
  opacity: 0.35;
}

.gl-select-button__item--disabled {
  cursor: not-allowed;
  opacity: 0.3;
}

.gl-select-button__gray {
  padding: 4px;
  background-color: var(--cotton-grey-f-5);
  border-radius: 10px;
}
.gl-select-button__gray .gl-select-button__item {
  color: var(--Basic-800, rgba(9, 21, 64, 0.68));
  font-style: normal;
  font-weight: 600;
  text-align: center;
  padding: 4px 8px;
  font-size: 14px;
  line-height: 20px;
  height: 32px;
  display: flex;
  align-items: center;
  gap: 2px;
  white-space: nowrap;
  transition:
      background-color 0.35s ease,
      color 0.35s ease,
      box-shadow 0.35s ease,
      transform 0.32s ease;
  will-change: transform;
}

.gl-select-button__gray--wide .gl-select-button__item {
  padding: 4px 40px;
}

.gl-select-button__item:active {
  transform: scale(0.96);
}

.gl-select-button__gray .gl-select-button__item--active {
  border-radius: 6px;
  background: var(--white);
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.10);
  height: 32px;
  color: var(--space-cadet);
  background-color: var(--white);
  opacity: unset;
}

.gl-select-button__gray .gl-select-button__item--active {
  transition:
      background-color 0.35s ease,
      color 0.35s ease,
      box-shadow 0.35s ease,
      transform 0.22s ease;
}

.gl-select-button__item--profit {
  width: max-content;
  display: flex;
  padding: 1px 4px;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 4px;
  top: -22px;
  border-radius: 4px 4px 0 0;
  background: linear-gradient(83deg, #194BFB 0.55%, #194BFB 16.37%, #CA0FA2 70.98%, #F1104E 98.1%);
  color: var(--white);
  text-align: center;
  font-size: var(--Size-S, 12px);
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
}

.gl-select-button__underline {
  padding: initial;
  background-color: initial;
  border-radius: initial;
  height: initial;
  background: var(--white, #fff);
}
.gl-select-button__underline .gl-select-button__item {
  color: var(--Basic-900, #091540);
  padding: 16px 4px;
  margin: 0 8px;
  font-size: 14px;
  line-height: var(--Line-Height-L, 20px);
  letter-spacing: var(--Letter-Spacing-S, -0.2px);
}
.gl-select-button__underline .gl-select-button__item:first-child {
  padding-left: 0;
  padding-right: 0;
}
.gl-select-button__underline .gl-select-button__item--active {
  color: var(--Brand-Main, #194bfb);
  background: var(--white, #fff);
  box-shadow: none;
}
.gl-select-button__underline .gl-select-button__item:after {
  content: '';
  width: 100%;
  height: 2px;
  background-color: transparent;
  border-radius: 2px;
  position: absolute;
  bottom: 0;
  left: 0;
  transition: background-color 0.3s ease;
}
.gl-select-button__underline .gl-select-button__item--active:after {
  background-color: var(--Brand-Main, #194bfb);
}

@media (max-width: 767px) {
  .gl-select-button-wrapper {
    width: 100%;
  }

  .gl-select-button__item {
    width: inherit;
    font-size: 14px;
  }
}
</style>
